import TwoFactorAuthenticationSwitch from "./TwoFactorAuthenticationSwitch";

export default TwoFactorAuthenticationSwitch;
